/**
 * 日別料金テーブル領域専用のローディング表示。
 * 期間ナビ・フィルタは Suspense 外に残し、ここだけ差し替える。
 */
export const PlanRateMatrixTableLoadingFallback = () => {
	return (
		<div
			className="flex min-h-48 flex-col items-center justify-center gap-3 rounded-lg border border-zinc-100 bg-zinc-50/80 px-4 py-10"
			role="status"
			aria-live="polite"
		>
			<div className="flex items-center gap-x-2">
				<span className="h-2 w-2 animate-bounce rounded-full bg-zinc-400 [animation-delay:-0.3s]" />
				<span className="h-2 w-2 animate-bounce rounded-full bg-zinc-400 [animation-delay:-0.15s]" />
				<span className="h-2 w-2 animate-bounce rounded-full bg-zinc-400" />
			</div>
			<p className="text-sm text-caption-50">料金データを読み込み中…</p>
		</div>
	);
};

PlanRateMatrixTableLoadingFallback.displayName = "PlanRateMatrixTableLoadingFallback";
